import React from "react";
import WrapPost from "../../../assets/styles/WrapPost";
import {Link} from "gatsby";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import {cleanText, stripPrefix} from "../../../function/functions";
import LazyGatsbyImage from "../../../function/LazyGatsbyImage";

function GetPosts({post, typeTitle}) {
    // console.log('post >>>>>>', post);

    return (
        <WrapPost className='wrap-post'>
            <div className="row-cols-1 row-cols-sm-2 row-cols-lg-3 row">
                {post?.map((item , index) => {
                    const imgAlt = item?.featuredImage?.node?.altText ? (
                        item?.featuredImage?.node?.altText
                    ) : (
                        `${item?.title} · Видавництво Мольфар`
                    );
                    const imgTitle = item?.title;
                    return (
                        <div key={`post_` + item.id + `_` + index} className="col">
                            <div className="itemPost h100 border-hor-bottom">
                                <Link to={stripPrefix(item.link)} className="WrapImg">
                                    {
                                        item.featuredImage ? (
                                            // <img className='img' alt={`${item.title} — Molfar`} title={item.title} src={item.featuredImage?.node.localFile?.publicURL} />
                                            <LazyGatsbyImage alt={imgAlt} title={imgTitle} className='img' image={ getImage(item.featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData) } />
                                            // <LazyGatsbyImage
                                            //     alt={imgAlt}
                                            //     title={imgTitle}
                                            //     className='img'
                                            //     // layout="fixed"
                                            //     loading="lazy"
                                            //     image={ item?.featuredImage?.node.localFile?.childImageSharp?.gatsbyImageData }
                                            // />
                                        ) : (
                                            <span className="logo" />
                                        )
                                    }
                                </Link>

                                <div className='wrap-text'>
                                    <div className="WrapDate d-flex align-items-center">
                                        <div className="date st5 fw-3">{item.date}</div>
                                        {/*{item.categories?.nodes.map((cat_item, i) => (*/}
                                        {/*    <Link key={`post_category` + item.id + `_` + index + `_` + i} className='st5 PostCategory fw-3'*/}
                                        {/*          to={cat_item.link}>{cat_item.name}*/}
                                        {/*    </Link>*/}
                                        {/*))} */}
                                    </div>
                                    <Link to={stripPrefix(item.link)} className="PostTitle">
                                        { typeTitle === 'h2' ? (<h2 className='fw-4'>{item.title}</h2>) : (<h3 className='fw-4'>{item.title}</h3>) }
                                    </Link>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </WrapPost>
    )
}

export default GetPosts;